import React, { useContext, useEffect, useRef, useState } from 'react';
import { FirebaseContext } from '../../context/FirebaseContext';
import Button from '../../NecttosComp/Button/Button';
import Input from '../../NecttosComp/Input/Input';
import { Body, Header, Main, closeAnimation } from '../../NecttosComp/Layout/Layout';
import moment from 'moment';
import { useQuery } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import { SubsidiaryRegisterMonthWise } from './SubsidiaryRegisterMonthWise';
import Input2 from '../../NecttosComp/Input/Input2';
import { message } from 'antd';
import Instruction from '../../Documentation/Instruction';

const getAccounts = (data) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/fees/getSubsidiaryRegister', {
			params: { ...data },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const SubsidiaryRegisterYearWise = ({ onClose }) => {
	const [loading, setLoading] = useState(false);
	const [newStartDate, setnewStartDate] = useState('');
	const [newEndDate, setNewEndDate] = useState('');
	const [state, setState] = React.useState({
		filterValue: '',
		page: 0,
		year: '',
	});
	const dataToFinancial = state?.year?.split('-');
	const startDate = dataToFinancial ? dataToFinancial?.[0] + '-06-01' : '';
	const endDate = dataToFinancial ? dataToFinancial?.[1] + '-05-31' : '';
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data, refetch: issuedBookRefetch } = useQuery(['pdReg777ister', state?.year], getAccounts({ collegeId, formate: 'MMMM-YYYY', startDate: newStartDate, endDate: newEndDate, setLoading }));
	const [date, setDate] = useState({ date: '', type: 'Government', subType: '' });

	useEffect(() => {
		setState((prev) => ({
			...prev,
			year: '',
		}));
	}, [newStartDate, newEndDate]);

	useEffect(() => {
		if (state?.year) {
			setnewStartDate(startDate);
			setNewEndDate(endDate);
		}
		issuedBookRefetch();
	}, [state]);

	const fetchOpeningBalance = async () => {
		const instance = await getAxiosTokenInstance();
		const res = await instance.get('/college/fees/getOpeningBalance', {
			params: { collegeId },
		});
		return {
			values: res.data.openingBalance,
			openingDate: res.data.openingDate,
			_id: res.data._id,
		};
	};

	const {
		data: openingBalance,
		refetch: refetchOpeningBalance,
		isLoading: openingLoading,
	} = useQuery(['openingBalance', collegeId], fetchOpeningBalance, {
		enabled: !!collegeId,
	});
	useEffect(() => {
		if (openingBalance?.values?.length > 0) {
			const restoredState = {
				openingDate: moment(openingBalance.openingDate).format('YYYY-MM-DD'),
			};

			openingBalance.values.forEach(({ accountId, amount }) => {
				restoredState[accountId] = amount;
			});

			setState((prev) => ({ ...prev, _id: openingBalance._id, ...restoredState }));
		}
	}, [openingBalance]);
	console.log('openingBalance', openingBalance);

	const addNewForm = async () => {
		try {
			const { openingDate, _id } = state;
			if (!openingDate) return alert('Opening Date is required');
			const values = Object.keys(data?.keyValueData || {}).map((key) => ({
				accountId: key,
				amount: parseFloat(state[key]) || 0,
			}));

			const instance = await getAxiosTokenInstance();
			await instance.post('/college/fees/SettingOpeningBalance', {
				openingDate,
				values,
				collegeId,
				uid: 'SYSTEM',
				_id,
			});

			await refetchOpeningBalance();
			message.success('Opening Balance Saved!');
			closeAnimation();
			setTimeout(() => setState((prev) => ({ ...prev, opeingBalance: false })), 500);
		} catch (err) {
			console.error('API Error', err);
			message.error('Failed to save opening balance');
		}
	};

	return (
		<>
			<Main title={'New Subsidiary Register'} height={'90vh'} width={'90vw'}>
				<Header width='100%'>
					<div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 w-full'>
						<div className='flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-2 w-full sm:w-auto'>
							<Input2 typable fieldName='Financial Year' setState={setState} state={state} returnKey='year' didntShow options={['2020-2021', '2021-2022', '2022-2023', '2023-2024', '2024-2025', '2025-2026']} type='drop' className='w-[160px]' />
							<Input2 type='date' state={newStartDate} fieldName='Start Date' setState={setnewStartDate} />
							<Input2 type='date' state={newEndDate} fieldName='End Date' setState={setNewEndDate} />
						</div>
						<div className='flex flex-wrap sm:flex-nowrap gap-2 items-center sm:ml-auto'>
							<Button type='fetch' onClick={issuedBookRefetch}>
								Proceed
							</Button>
							<Button
								type='fetch'
								onClick={async () => {
									await refetchOpeningBalance();
									setState((prev) => ({ ...prev, opeingBalance: true }));
								}}>
								Setup Opening Balance
							</Button>
							<Button type='print' tableRef={componentRef.current}>
								Print
							</Button>
							<Instruction keyId={'subsidiaryRegisterYearWise'}/>
							<Button
								type='close'
								onClick={() => {
									closeAnimation();
									setTimeout(onClose, 250);
								}}>
								Close
							</Button>
						</div>
					</div>
				</Header>

				<Body>
					<div ref={componentRef} className='printable'>
						<div className='flex flex-col sm:flex-row sm:items-center sm:justify-between p-4 border-b-2 gap-4 sm:gap-0'>
							<div className='flex flex-col sm:flex-row sm:items-center sm:gap-4'>
								<div className='flex justify-center sm:justify-start'>
									<img className='w-16 h-16' src={selectedCollege?.logo} alt='College Logo' />
								</div>
								<div className='text-center sm:text-left'>
									<h1 className='text-xl font-bold dark:text-slate-100'>{selectedCollege?.collegeShortName}</h1>
									<p className='text-md font-semibold dark:text-slate-100'>{selectedCollege?.accreditedGrade}</p>
									<p className='text-md font-semibold dark:text-slate-100'>{selectedCollege?.address}</p>
								</div>
							</div>
							<div className='text-center sm:text-right'>
								<p className='text-xl font-medium dark:text-slate-100'>Subsidiary Register YearWise</p>
								<p className='text-md font-medium dark:text-slate-100'>
									{date.type} - {date.subType}
								</p>
								<p className='text-sm font-medium dark:text-slate-100'>
									{moment(date.date).format('DD MMM YYYY')} to {moment(date.endDate).format('DD MMM YYYY')}
								</p>
								<p className='text-sm font-medium dark:text-slate-100'>Print at {moment(new Date()).format('DD MMM YYYY hh:mm A')}</p>
							</div>
						</div>

						{data?.subsidiaryRegisterData.length > 0 && (
							<div className='w-full'>
								<Table width='100%' innerWidth={['5%', '22%', '5%', '16%', ...Array.from({ length: 13 }, () => '8%'), '8%', '8%']}>
									<Thead>
										<Tr>
											<Th position={0}>SN</Th>
											<Th position={1}>Date</Th>
											<Th position={2}>C</Th>
											<Th position={3}>Rt.No.</Th>
											{Array.from({ length: 13 }, (_, i) => (
												<Th key={i} position={4 + i}>
													{data?.keyValueData[`specialFee${i + 1}`]}
												</Th>
											))}
											<Th position={17}>TOTAL</Th>
											<Th position={18}>PAY</Th>
										</Tr>
									</Thead>
									<Tbody>
										{/* Opening Balance Row */}
										{openingBalance?.values?.length > 0 && (
											<Tr className='bg-yellow-100 font-semibold'>
												<Td position={0}>OB</Td>
												<Td position={1}>{moment(openingBalance.openingDate).format('DD-MM-YYYY')}</Td>
												<Td position={2}>–</Td>
												<Td position={3}>Opening Balance</Td>
												{Array.from({ length: 13 }, (_, idx) => {
													const id = `specialFee${idx + 1}`;
													const fee = openingBalance.values.find((v) => v.accountId === id);
													return (
														<Td key={idx} position={4 + idx}>
															{fee?.amount || 0}
														</Td>
													);
												})}
												<Td position={17}>{openingBalance.values.reduce((sum, entry) => sum + (entry.amount || 0), 0)}</Td>
												<Td position={18}>0</Td>
											</Tr>
										)}
										{data?.subsidiaryRegisterData.map((item, i) => (
											<Tr key={i} onClick={() => setState({ ...state, openModal: true, selectedDate: item.dateActual })}>
												<Td position={0}>{i + 1}</Td>
												<Td position={1}>{item?.date}</Td>
												<Td position={2}>{item?.countData}</Td>
												<Td position={3}>{item?.recieptNumber}</Td>
												{Array.from({ length: 13 }, (_, idx) => (
													<Td key={idx} position={4 + idx}>
														{item[`specialFee${idx + 1}`]}
													</Td>
												))}
												<Td position={17}>{item?.totalAmount}</Td>
												<Td position={18}>{item?.paymentAmount}</Td>
											</Tr>
										))}
										<Tr>
											<Td position={0}></Td>
											<Td position={1}></Td>
											<Td position={2}></Td>
											<Td position={3}></Td>
											{Array.from({ length: 13 }, (_, idx) => (
												<Td key={idx} position={4 + idx}>
													{data?.totals?.[`specialFeeMainTotal${idx + 1}`]}
												</Td>
											))}
											<Td position={17}>{data?.totals?.grandTotal}</Td>
											<Td position={18}>{data?.totals?.grandPayment}</Td>
										</Tr>
									</Tbody>
								</Table>
								<h5 className='mt-3 text-right dark:text-slate-100 text-sm font-medium'>Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</h5>
							</div>
						)}
					</div>

					{state.openModal && <SubsidiaryRegisterMonthWise date={state?.selectedDate} onClose={() => setState({ ...state, openModal: false })} />}
				</Body>

				{state.opeingBalance && (
					<Main width='50vw' height='100%'>
						<Header>
							<Button
								type='close'
								onClick={() => {
									closeAnimation();
									setTimeout(() => setState({ ...state, opeingBalance: false }), 500);
								}}>
								Close
							</Button>
							<Button
								type='save'
								onClick={() => {
									addNewForm();
								}}>
								Save
							</Button>
						</Header>
						<Body>
							<div className='flex flex-col w-full'>
								<Input2 width='99%' fieldName='Opening Date' returnKey='openingDate' state={state} setState={setState} type='date' />
								{Object.keys(data?.keyValueData).map((item, i) => (
									<Input2 key={i} width='99%' fieldName={data.keyValueData[item]} returnKey={item} state={state} setState={setState} type='number' />
								))}
							</div>
						</Body>
					</Main>
				)}
			</Main>
		</>
	);
};
